import Chart from 'react-apexcharts'
import { ApexOptions } from 'apexcharts'
import { webApiService } from '../DashboardIndex'
import { useDashboard } from '../context/DashboardContext'
import { useEffect, useState } from 'react'
import { Spinner } from '@nextui-org/react'
import { HiOutlineArrowsExpand, HiOutlineOfficeBuilding, HiOutlineStar } from 'react-icons/hi'
import { HiOutlineArrowsPointingIn } from 'react-icons/hi2'

interface Value {
    byStore: {
        storeSeries: number[]
        storeLabels: string[]
    },
    byBrand: {
        series: number[]
        labels: string[]
    }
}

const initialData = {
  byStore: {
    storeSeries: [],
    storeLabels: []
  },
  byBrand: {
    series: [],
    labels: []
  }
}

export default function SecondCharts () {
  const { dateRange, selectedSeller, selectedRegion, selectedStore, incrementLoadingCards, decrementLoadingCards } = useDashboard()
  const [loading, setLoading] = useState<boolean>(true)
  const [value, setValue] = useState<Value>(initialData)
  const [expanded, setExpanded] = useState(false)

  // console.log('value => ', value)

  useEffect(() => {
    let cancelled = false

    const loadData = async () => {
      setLoading(true)
      incrementLoadingCards()

      const response = await Promise.all([
        webApiService.getByStore({ start: String(dateRange.start), end: String(dateRange.end), idSeller: selectedSeller, region: selectedRegion || null, store: selectedStore || null }).then(res => res.data),
        webApiService.getModelsByBrand({ start: String(dateRange.start), end: String(dateRange.end), idSeller: selectedSeller, region: selectedRegion || null, store: selectedStore || null }).then(res => res.data)
      ])

      console.log('response => ', response)

      const result = {
        byStore: {
          storeSeries: response[0].storeSeries,
          storeLabels: response[0].storeLabels
        },
        byBrand: {
          series: response[1].series,
          labels: response[1].labels
        }
      }

      console.log('result => ', result)

      if (!cancelled) {
        setValue(result)
        setLoading(false)
      }
      decrementLoadingCards()
    }

    loadData()

    return () => {
      cancelled = true
    }
  }, [dateRange, selectedRegion, selectedStore]) // eslint-disable-line react-hooks/exhaustive-deps

  const storeCategoryCount = value.byStore.storeLabels.length
  const storeBarColumnWidth = storeCategoryCount <= 3 ? '30px' : '60%'

  const barOptions: ApexOptions = {
    chart: {
      type: 'bar',
      toolbar: { show: false },
      fontFamily: 'inherit'
    },
    plotOptions: {
      bar: {
        borderRadius: 4,
        columnWidth: storeBarColumnWidth
      }
    },
    colors: ['#6366f1', '#3b82f6', '#7c3aed'],
    xaxis: {
      categories: value.byStore.storeLabels,
      labels: { style: { colors: '#8492a6', fontSize: '11px' }, rotate: -45 }
    },
    yaxis: {
      labels: { style: { colors: '#8492a6' } }
    },
    legend: {
      position: 'bottom',
      fontSize: '13px',
      labels: { colors: '#44526B' }
    },
    dataLabels: { enabled: false },
    grid: { borderColor: '#f0f0f0' },
    tooltip: { theme: 'light' }
  }

  const donutOptions: ApexOptions = {
    chart: {
      type: 'donut',
      fontFamily: 'inherit'
    },
    labels: value.byBrand.labels,
    colors: ['#3b82f6', '#7c3aed', '#6366f1', '#a78bfa'],
    legend: {
      position: 'left',
      fontSize: '13px',
      labels: { colors: '#44526B' }
    },
    dataLabels: {
      enabled: true,
      formatter: (val: number) => `${val.toFixed(1)}%`
    },
    plotOptions: {
      pie: {
        donut: {
          size: '55%'
        }
      }
    },
    tooltip: { theme: 'light' }
  }

  return (
    <div className={`grid grid-cols-1 gap-6 ${expanded ? '' : 'lg:grid-cols-2'}`}>
      <div className='bg-white rounded-2xl shadow-sm border border-gray-100 p-6'>
        <div className='flex items-center justify-between mb-1'>
          <div className='flex items-center gap-2 text-sm font-semibold text-[#8492a6]'>
            <HiOutlineOfficeBuilding size={18} />
            Retomas por tienda
          </div>
          <button onClick={() => setExpanded(!expanded)} className='text-[#8492a6] hover:text-[#44526B] transition-colors hidden'>
            {expanded ? <HiOutlineArrowsPointingIn size={18} /> : <HiOutlineArrowsExpand size={18} />}
          </button>
        </div>
        {loading
          ? <div className='flex items-center justify-center h-[300px]'><Spinner size='lg' color='primary' /></div>
          : value.byStore.storeLabels.length === 0
            ? <div className='flex items-center justify-center h-[300px] text-sm text-[#8492a6]'>Sin datos disponibles</div>
            : <Chart options={barOptions} series={[{ name: 'Retomas', data: value.byStore.storeSeries }]} type='bar' height={300} />}
      </div>
      <div className='bg-white rounded-2xl shadow-sm border border-gray-100 p-6'>
        <div className='flex items-center gap-2 text-sm font-semibold text-[#8492a6]'>
          <HiOutlineStar size={18} />
          Modelos más vendidos por marca
        </div>
        {loading
          ? <div className='flex items-center justify-center h-[300px]'><Spinner size='lg' color='primary' /></div>
          : value.byBrand.labels.length === 0
            ? <div className='flex items-center justify-center h-[300px] text-sm text-[#8492a6]'>Sin datos disponibles</div>
            : <Chart options={donutOptions} series={value.byBrand.series} type='donut' height={300} />}
      </div>
    </div>
  )
}
